import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/shared/integrations/supabase/client";

export interface RecycledRow {
  id: string;
  name: string;
  category_id: string | null;
  deleted_at: string | null;
}

/** Hook: fetches a property's soft-deleted assets via the recycle-bin RPC. */
export function useRecycledPropertyAssets(propertyId: string | null) {
  return useQuery<RecycledRow[]>({
    queryKey: ["recycled-assets", propertyId],
    queryFn: async (): Promise<RecycledRow[]> => {
      if (!propertyId) return [];
      const { data, error } = await supabase.rpc("list_recycled_property_assets", {
        p_property_id: propertyId,
      });
      if (error) throw error;
      return (data ?? []).map((r) => ({
        id: r.id,
        name: r.name,
        category_id: r.category_id,
        deleted_at: r.deleted_at,
      }));
    },
    enabled: !!propertyId,
    staleTime: 60 * 1000,
  });
}
